import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import Form from '../../forms/Form.js';
import Modal from '../../modals/Modal.js';
import ModalBuilder$1 from '../../../cinnamon-core/es/components/builders/ModalBuilder.js';

var QuillInsertLink = function QuillInsertLink(_ref) {
  var quill = _ref.quill,
      open = _ref.open,
      onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(ModalBuilder$1, {
    withForm: true,
    visible: open,
    onLoad: function onLoad() {
      if (!quill) return {};
      var editor = quill.getEditor();
      var format = editor.getFormat();
      return format.link ? {
        link: format.link
      } : {};
    },
    onSubmit: function onSubmit(_ref2) {
      var link = _ref2.link;
      if (!quill) return;
      quill.focus();
      var editor = quill.getEditor();
      var range = editor.getSelection();
      if (!range) return;
      var cursorPosition = range.index;
      var selection = editor.getText(cursorPosition, range.length);
      var source = "user";

      if (selection.length > 0) {
        var format = editor.getFormat();
        if (format.link === link) return;
        editor.removeFormat(range.index, range.length, source);
        editor.format("link", link, source);
      } else {
        editor.insertText(cursorPosition, link, source);
        editor.formatText(cursorPosition, link.length, "link", link, source);
      }
    },
    onSubmitted: onClose,
    onCancelled: onClose,
    renderModal: function renderModal(modalProps, formProps) {
      return /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps, {
        header: "Insert Link",
        submitLabel: "Insert",
        size: "sm"
      }), /*#__PURE__*/React.createElement(Form, formProps, /*#__PURE__*/React.createElement(Form.Url, {
        field: "link",
        label: "URL",
        fluid: true,
        required: true,
        formatValue: true
      })));
    }
  });
};

QuillInsertLink.propTypes = {
  quill: propTypes.any,
  open: propTypes.bool,
  onClose: propTypes.func
};
var QuillInsertLink$1 = QuillInsertLink;

export { QuillInsertLink$1 as default };
